import React, { useEffect, useState } from 'react'
import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'
import rtlPlugin from 'stylis-plugin-rtl'
import { useTranslation } from 'react-i18next'
import NavBar from './NavBar'
import { ThemeProvider } from '@mui/material/styles'
import theme from '../Components/Theme'
import Categorisation from '../containers/categorisation'
import CurrentAccount from './CurrentAccount'
import Calendar from '../containers/Time'
// import CategorizationTable from "../Components/CategorizationTable";
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom'
import ManageCategories from '../Components/ManageCategories'
import HomePage from '../containers/HomePage'
import MesComptes from '../containers/mesComptes'
import Catalogue from '../containers/catalogue'
import MainPageFiState from '../containers/fiStatement/MainFiStat'
import MainDashBoard from '../containers/DashBoard/MainBoard'
import SyntheseTemps from '../containers/SyntheseTemps/MainBoard'
import { AppContext } from '../context'
import DashboardDetail from '../containers/fiStatement/DashboardDetail'
import { GestionOperations } from '../containers/GestionOperations'
import { PlanEntretien } from '../containers/Domicile/PlanEntretien'
import { EntretienDetails } from '../containers/Domicile/PlanEntretien/EntretienDetails'
import { MesVehicules } from '../containers/Domicile/MesVehicules'
import { VehicleDetails } from '../containers/Domicile/MesVehicules/VehicleDetails'
import { HistoriqueVHkm } from '../containers/Domicile/MesVehicules/VehicleDetails/HistoriqueVHkm'
import { HistoriqueValo } from '../containers/Domicile/MesVehicules/VehicleDetails/HistoriqueValo'
import { Financement } from '../containers/Domicile/MesVehicules/VehicleDetails/Financement'
import { ImmoFinancement } from '../containers/Domicile/MonImmobilier/DocumentDetails/ImmoFinancement'
import { DetailDepense } from '../containers/Domicile/MesVehicules/VehicleDetails/DetailDepense'
import { MesOjectifs } from '../containers/MesObjectifs'
import { DocumentDetails } from '../containers/Domicile/MonImmobilier/DocumentDetails'
import { MonImmobilier } from '../containers/Domicile/MonImmobilier'
import { MesDocuments } from '../containers/MesDocuments'
import { MesContacts } from '../containers/MesContacts'
import { MaBucketList } from 'containers/Personnal/BucketList'
import { ImmoValue } from 'containers/Domicile/MonImmobilier/DocumentDetails/ImmoValue'
import { ImmoDetailDepense } from '../containers/Domicile/MonImmobilier/DocumentDetails/ImmoDetailDepense'
import { MonParcoursPro } from '../containers/Pro/MonParcoursPro'
import { Mesplantes } from '../containers/Garden'
import PlantDetail from '../containers/Garden/PlantView'
import Search from './Search'
// import {DashBoard} from 'containers/DashBoard'
// import ScrollToTop from './ScrollToTop'
import { ExperienceDetails } from 'containers/Pro/MonParcoursPro/ExperienceDetails'
import { FormationDetails } from '../containers/Pro/MonParcoursPro/FormationDetails'
import { MesToDo } from '../containers/MesToDo'
import { MesRecettes } from '../containers/Personnal/MesRecettes'
import { RecettesCategory } from 'containers/Personnal/RecettesCategory'
import { RecetteDetails } from '../containers/Personnal/MesRecettes/RecetteDetails'
import Menu from '../containers/Personnal/PlanMeal'
// import { Box } from '@mui/material'
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import MonBudget from '../containers/MonBudget'
import MonPatrimoine from '../containers/MonPatrimoine/MainBoard'
import { useLocation } from 'react-router-dom'
import Login from '../containers/auth/Login'
import Register from 'containers/auth/Register'
import { ProtectedRoute, ProtectedRoute1 } from './ProtectedRoutes'
import Verify from '../containers/auth/Verify'
import ResetPassword from 'containers/auth/ResetPassword'
import PolicyViewer from '../containers/legal/PolicyViewer'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import StoreProvider from '../reduxLib/StoreProvider'
import OpenBank from './OpenBank'
import { useSelector } from 'react-redux'
import UserWizardPage from './UserWizardPage'
import DefinirObjective from './DefinirObjective'
import TimeList from './TimeList'
import SelectionMesObjective from './SelectionMesObjective'
import GeneralReport from './LifeReports/GeneralReport'
import GeneralReportEnhanced from './LifeReports/GeneralReportEnhanced'
import NotFound from './NotFound'
import ATestPage from './ATestPage'
import GoogleAuth from './GoogleAuth'
import Opportunities from 'containers/Opportunities'
import MyInbox from '../containers/MyInbox'
import Shopping from 'containers/Shopping'
import Roadmap from 'containers/Roadmap'
import SubscriptionPlanModal from './SubscriptionPlanModal'
import { Box } from '@mui/material'
import SyntheseProfessionnelle from '../containers/SyntheseProfessionnelle/MainBoard'
import { TempsDeTravail } from '../containers/Pro/TempsDeTravail'
import Investments from '../containers/Investments'
import { ConseillerPatrimonialPage } from '../containers/ConseillerPatrimonial'
import Subscription from './Subscription'
import SubscriptionSuccess from './SubscriptionSuccess'
import AccessDenied from 'AccessDenied'
import { AppAccessRoute } from './AppAccessRoute'
// Système de crédits Life — modale globale "Crédits insuffisants" (HTTP 402)
import { InsufficientCreditsModal } from './Billing'

const cacheLtr = createCache({ key: 'mui' })
const cacheRtl = createCache({ key: 'muirtl', stylisPlugins: [rtlPlugin] })

const App = () => {
  const { i18n } = useTranslation()
  const [tableAccount, setTableAccount] = useState('')
  const [userSync, setUserSync] = useState(false)
  const location = useLocation()
  const token = localStorage.getItem('token')
  const currentLanguage = (i18n.language || 'fr').split('-')[0]
  const isRtl = currentLanguage === 'ar'

  const getCookie = (name) => {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
  }

  // useEffect(() => {
  //   // console.log(path)
  //   // if (path === '/' && !token) {
  //   //   navigate('/login')
  //   // }
  //   console.log('sdfd')
  // }, [])
  useEffect(() => {
    let ap_v = localStorage.getItem('life_app')
    let sp_v = getCookie('life_app')
    if (ap_v && sp_v) {
      if (ap_v !== sp_v) {
        localStorage.setItem('life_app', sp_v)
        window.location.reload()
        return
      }
    } else {
      if (sp_v) {
        localStorage.setItem('life_app', sp_v)
      }
    }
  }, [location])

  useEffect(() => {
    document.documentElement.setAttribute('lang', currentLanguage)
    document.documentElement.setAttribute('dir', isRtl ? 'rtl' : 'ltr')
    document.body.setAttribute('dir', isRtl ? 'rtl' : 'ltr')
  }, [currentLanguage, isRtl])

  const dispatchAccountClick = (actionType, payload) => {
    switch (actionType) {
      case 'CLICK':
        setTableAccount(payload.id)
        return
      default:
        return
    }
  }

  return (
    <AppContext.Provider value={{ tableAccount, dispatchAccountClick }}>
      <CacheProvider value={isRtl ? cacheRtl : cacheLtr}>
        <div style={{ backgroundColor: '#00001d', minHeight: '100vh' }}>
          <ToastContainer rtl={isRtl} />
          {/* <div style={{ backgroundColor: '#00001d', minHeight: '100vh' }}> */}

          {/* <CategorizationTable /> */}

          <ThemeProvider theme={theme}>
            <Routes>
              {/* Public routes for legal policies */}
              <Route path="/legal/policies/:policyType" element={<PolicyViewer />} />
              
              <Route element={<ProtectedRoute1 />}>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/verify/:code" element={<Verify />} />
                <Route path="/reset-password/:code" element={<ResetPassword />} />
              </Route>
            </Routes>
            <StoreProvider>
              {!token ? <AppCheck /> : <NavBar setUserSync={setUserSync} />}
              {userSync && <AppRouters />}
              {/* Modale globale "Crédits insuffisants" — écoute l'évènement DOM
                  émis par utils/api.js sur HTTP 402. Une seule instance suffit
                  pour toute l'app, quel que soit l'endpoint IA qui a renvoyé
                  402. Cf. spec §4.4. */}
              {token && <InsufficientCreditsModal />}
            </StoreProvider>
          </ThemeProvider>
        </div>
      </CacheProvider>
    </AppContext.Provider>
  )
}

export default App

const AppCheck = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const token = localStorage.getItem('token')
  const path = location.pathname

  useEffect(() => {
    if (
      path.startsWith('/login') ||
      path.startsWith('/register') ||
      path.startsWith('/verify/') ||
      path.startsWith('/reset-password/') ||
      path.startsWith('/legal/policies/')
    ) {
    } else {
      if (!token) {
        navigate('/login')
      }
    }
  }, [path, token, navigate])
  return <>.</>
}
const AppRouters = () => {
  const siteUser = useSelector((store) => store.user)
  const [completed, setCompleted] = useState(false)
  const [wStep, setWSetp] = useState('')
  
  useEffect(() => {
    // first_login_completed: true = onboarding done, false/undefined = show wizard
    const firstLoginCompleted = siteUser.user?.first_login_completed === true

    let checkcompleted = false
    let user_wizard = siteUser.user?.user_wizard
    let step = ''

    if (user_wizard && user_wizard.length > 0) {
      const orderedWizard = [...user_wizard]

      for (let i = 0; i < orderedWizard.length; i++) {
        if (!orderedWizard[i].completed && !orderedWizard[i].skip) {
          step = orderedWizard[i].step
          checkcompleted = false
          break
        }
      }

      if (!step) {
        checkcompleted = true
      }

      if (checkcompleted && firstLoginCompleted) {
        setCompleted(true)
        setWSetp('')
      } else if (step) {
        setWSetp(step)
        setCompleted(false)
      } else if (!firstLoginCompleted) {
        setCompleted(false)
        setWSetp('Welcome')
      } else {
        setCompleted(true)
        setWSetp('')
      }
    } else if (!firstLoginCompleted) {
      // First connection or no wizard data: show Welcome
      setCompleted(false)
      setWSetp('Welcome')
    } else {
      setCompleted(true)
      setWSetp('')
    }
  }, [siteUser])

  // When user has no subscription, block app until they choose a plan (subscription modal first, then onboarding).
  if (siteUser.user && siteUser.user.has_subscription !== true) {
    return (
      <Box sx={{ minHeight: '100vh', width: '100%', bgcolor: '#00001d', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <SubscriptionPlanModal open={true} blocking={true} onClose={() => {}} />
      </Box>
    )
  }
  
  return (
    <>
      <Routes>
        <Route path="/access-denied" element={<AccessDenied />} />
        {/* LAP-739 Bug 3 — /choose-plan now renders the SubscriptionPlanModal as
            a full-screen page so the "Voir les offres" CTA in Life Settings
            actually lands somewhere useful. /subscription kept as a redirect
            alias to preserve historical deep links. */}
        <Route
          path="/choose-plan"
          element={
            <Box sx={{ minHeight: '100vh', width: '100%', bgcolor: '#00001d', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <SubscriptionPlanModal open={true} blocking={false} onClose={() => window.history.back()} />
            </Box>
          }
        />
        <Route path="/subscription" element={<Navigate to="/choose-plan" replace />} />
        <Route path="/payment-success" element={<SubscriptionSuccess />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={
            completed ? <HomePage /> : 
            (!completed && wStep) ? <UserWizardPage step={wStep} /> : 
            <HomePage />
          } />
          <Route path="/open-bankac" element={<OpenBank />} />
          {/* <Route path="/Dashboard" element={<DashBoard />} /> */}
          <Route path="/mescomptes" element={<MesComptes />} />
          <Route path="/compte/:id" element={<CurrentAccount />} />

          <Route path="/categorisation" element={<Categorisation />} />
          <Route path="/Fistatement" element={<MainPageFiState />} />
          <Route path="/Dashboard" element={<AppAccessRoute requiredLien="/Dashboard"><MainDashBoard /></AppAccessRoute>} />

          <Route path="/categorization/managecategories" element={<ManageCategories />} />
          <Route path="/catalogue" element={<Catalogue />} />
          <Route path="/dashboard-detail/:slug" element={<DashboardDetail />} />

          <Route path="/gestionoperations" element={<GestionOperations />} />
          <Route path="/mesobjectifs" element={<MesOjectifs />} />
          <Route path="/domicile/monimmobilier" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><MonImmobilier /></AppAccessRoute>} />
          <Route path="/domicile/monimmobilier/monbien/:id" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><DocumentDetails /></AppAccessRoute>} />
          <Route path="/domicile/entretien" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><PlanEntretien /></AppAccessRoute>} />
          <Route path="/domicile/entretien/:id" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><EntretienDetails /></AppAccessRoute>} />
          <Route path="/domicile/mesvehicules" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><MesVehicules /></AppAccessRoute>} />
          <Route path="/domicile/vehicule/:id" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><VehicleDetails /></AppAccessRoute>} />
          <Route path="/domicile/detaildepense/vehicule/:id" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><DetailDepense /></AppAccessRoute>} />
          <Route path="/domicile/historiquekm/vehicule/:id" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><HistoriqueVHkm /></AppAccessRoute>} />
          <Route path="/domicile/historiquevalo/vehicule/:id" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><HistoriqueValo /></AppAccessRoute>} />
          <Route path="/domicile/immovalue/immobilier/:id" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><ImmoValue /></AppAccessRoute>} />
          <Route path="/domicile/detaildepense/immobilier/:id" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><ImmoDetailDepense /></AppAccessRoute>} />
          <Route path="/domicile/financement/vehicule/:id" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><Financement /></AppAccessRoute>} />
          <Route path="/domicile/financement/immobilier/:id" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><ImmoFinancement /></AppAccessRoute>} />
          <Route path="/search/:id/:q" element={<Search />} />
          {/* <Route path="/domicile/monimmobilier" element={<MonImmobilier />} /> */}
          {/* <Route path="/domicile/monimmobilier/monbien/:id" element={<DocumentDetails />} /> */}
          <Route path="/documents" element={<AppAccessRoute requiredLien="/documents"><MesDocuments /></AppAccessRoute>} />
          <Route path="/MonCalendrier" element={<Calendar />} />
          <Route path="/MesContacts" element={<MesContacts />} />
          <Route path="/BucketList" element={<MaBucketList />} />
          {/* <Route path="/search/:id/:q" element={<Search />} /> */}
          <Route path="/Mesplantes" element={<Mesplantes />} />
          <Route path="/Mesplantes/detail/:id" element={<PlantDetail />} />
          <Route path="/parcourspro" element={<MonParcoursPro />} />
          <Route path="/parcourspro/experience/:id" element={<ExperienceDetails />} />
          <Route path="/parcourspro/formation/:id" element={<FormationDetails />} />
          <Route path="/todos/*" element={<MesToDo />} />
          <Route path="/recette" element={<MesRecettes />} />
          <Route path="/recette/:id" element={<RecetteDetails />} />
          <Route path="/recette-category" element={<RecettesCategory />} />
          <Route path="/Menu" element={<Menu />} />
          <Route path="/syntheseTemps" element={<SyntheseTemps />} />
          <Route path="/Monbudget" element={<MonBudget />} />
          <Route path="/MonPatrimoine" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><MonPatrimoine /></AppAccessRoute>} />
          <Route path="/MonPatrimoine/:questionnaire" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><MonPatrimoine /></AppAccessRoute>} />
          <Route path="/definir-objective" element={<DefinirObjective />} />
          <Route path="/user-timelist" element={<TimeList />} />
          <Route path="/definir-selection" element={<SelectionMesObjective />} />
          <Route path="/life-report/general/:m/:y/:q" element={<GeneralReport />} />
          <Route path="/life-resume" element={<GeneralReportEnhanced />} />
          <Route path="/opportunities" element={<Opportunities />} />
          <Route path="/inbox" element={<MyInbox />} />
          <Route path="/shopping" element={<Shopping />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/professionnelle" element={<SyntheseProfessionnelle />} />
          <Route path="/professionnelle/soft-skills" element={<SyntheseProfessionnelle />} />
          <Route path="/tempsdetravail" element={<TempsDeTravail />} />
          <Route path="/investments" element={<Investments />} />
          <Route path="/conseiller-patrimonial" element={<ConseillerPatrimonialPage />} />
          {/* Système de crédits : on ne crée PAS de page dédiée — la gestion
              des crédits (solde, achat de packs, historique) est intégrée
              dans la page Abonnement existante. Les anciennes URLs /billing*
              redirigent vers /subscription pour ne pas casser d'éventuels
              liens partagés ou Stripe Checkout success_url historiques. */}
          <Route path="/billing" element={<Navigate to="/subscription" replace />} />
          <Route path="/billing/packs" element={<Navigate to="/subscription" replace />} />
          <Route path="/billing/packs/success" element={<SubscriptionSuccess />} />
          <Route path="/oauth2callback" element={<GoogleAuth />} />
          <Route path="/microsoft" element={<GoogleAuth />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/testpage" element={<ATestPage />} />
        </Route>
      </Routes>
    </>
  )
}
